import { actionCreator } from '@ardoq/rxbeach';
import { ButtonConfig } from '@ardoq/view-settings';

export type CollapseExpandAllGroupsButtonsPropsState = {
  expandCollapseAllButtonConfig: ButtonConfig[];
};
export const collapseExpandAllGroupsButtonsPropsChange =
  actionCreator<CollapseExpandAllGroupsButtonsPropsState>(
    '[simple_block_diagram] COLLAPSE_EXPAND_ALL_GROUPS_BUTTON_PROPS'
  );
